import create from "zustand";

interface PurchasePageStoreState {
    lastSelectedPurchase?: ID;
    lastSelectedItem?: ID;
}

export const usePurchasePageStore = create<PurchasePageStoreState>(() => ({}));
